import { type ReactNode, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { ErrorState } from '@repo/design-system-kit';
import window from 'ember-window-mock';
import { Loading } from 'receivable-invoices-js/react/components/shared/loading/loading';
import { useRouteQuery } from './use-route-query';
import styles from './layout.module.css';

export function MollieActivationRoute(): ReactNode {
  const { formatMessage } = useIntl();
  const { origin, isLoading, error, refetch } = useRouteQuery();

  useEffect(() => {
    if (origin) {
      window.location.replace(origin);
    }
  }, [origin]);

  // Show loading while fetching or when we have origin and are about to navigate to qonto-js
  if (isLoading || origin) {
    return (
      <main className={styles.mollieActivation}>
        <Loading spinnerSize="large" />
      </main>
    );
  }

  if (error === 'not_found') {
    return (
      <main className={styles.mollieActivation}>
        <ErrorState
          data-test-error-state="not-found-error"
          headingLevel="h1"
          subtitle={formatMessage({ id: 'error-states.generic.legend' })}
          title={formatMessage({ id: 'error-states.generic.title' })}
        />
      </main>
    );
  }

  if (error) {
    return (
      <main className={styles.mollieActivation}>
        <ErrorState
          data-test-error-state="server-error"
          headingLevel="h1"
          onRetry={refetch}
          retryButtonVariant="secondary"
          subtitle={formatMessage({ id: 'error-states.mollie-activation.legend' })}
          title={formatMessage({ id: 'error-states.mollie-activation.title' })}
        />
      </main>
    );
  }

  // Fallback loading state (successful activation should redirect before reaching here)
  return (
    <main className={styles.mollieActivation}>
      <Loading spinnerSize="large" />
    </main>
  );
}
